import { useCallback, useState } from "react";
import { ApiError, postApi } from "../../../../utils/api.ts";
import { accessToken } from "../../../../utils/auth.ts";
import { API_OFFBOARDING_WITHDRAW } from "../../../../../config/Endpoints.js";
import { useSqeLabs } from "../../../../hooks/use-sqe-labs.ts";
import { SQE_OFFBOARDING_URL } from "../api/sqe-offboarding-api.ts";

interface WithdrawArgs {
    offboardingId: number;
    reason: string;
}

export function useOffboardingWithdraw() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const isSqe = useSqeLabs();

    const withdraw = useCallback(async ({ offboardingId, reason }: WithdrawArgs) => {
        setLoading(true);
        setError(null);

        const payload = { offboardingId, reason };

        try {
            await postApi(
                isSqe ? `${SQE_OFFBOARDING_URL}/withdraw` : API_OFFBOARDING_WITHDRAW,
                accessToken(),
                payload as unknown as Record<string, unknown>,
            );
            return true;
        } catch (e) {
            const msg =
                e instanceof ApiError
                    ? e.message
                    : "Failed to withdraw offboarding request.";
            setError(msg);
            return false;
        } finally {
            setLoading(false);
        }
    }, [isSqe]);

    return { withdraw, loading, error };
}
